

import React, { useState, useEffect } from 'react';


import Header from './components/Header';
import Footer from './components/Footer';
import AddToCartPopup from './components/AddToCartPopup';
import HomePage from './pages/HomePage';
import CategoryPage from './pages/CategoryPage';
import ProductDetailPage from './pages/ProductDetailPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import WarrantyPolicyPage from './pages/WarrantyPolicyPage';
import SearchPage from './pages/SearchPage';
import CartPage from './pages/CartPage';
import Registro from './pages/Registro';
import LoginPage from './pages/Login';
import MisPedidosPage from './pages/MisPedidos';
import MiCuenta from './pages/MiCuenta';


import PurchaseConfirmationModal from './components/PurchaseConfirmationModal';
import { routes } from './routes';
import { supabase } from './supabaseClient';
import emailjs from 'emailjs-com';

import AOS from 'aos';
import 'aos/dist/aos.css';



const App = () => {


const [user, setUser] = useState(() => {
  try { return JSON.parse(localStorage.getItem('elAnclaUser')); } catch { return null; }
});

const handleLoggedIn = (u) => {
  setUser(u);
  localStorage.setItem('elAnclaUser', JSON.stringify(u));
};

const handleLogout = () => {
  setUser(null);
  localStorage.removeItem('elAnclaUser');
  handleNavigate(routes.home);
};




  const [currentPage, setCurrentPage] = useState(window.location.pathname);
  const [currentProductId, setCurrentProductId] = useState(null);
  const [cartItems, setCartItems] = useState([]);
  const [showAddToCartPopup, setShowAddToCartPopup] = useState(false);
  const [popupProduct, setPopupProduct] = useState(null);
  const [showPurchaseConfirmation, setShowPurchaseConfirmation] = useState(false);
  const [lastOrderDetails, setLastOrderDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
useEffect(() => {
  AOS.init({
    duration: 1000, // duración por defecto
    once: true ,
     offset: 120,         
  });
}, []);


  useEffect(() => {
    const handlePopState = () => {
      setCurrentPage(window.location.pathname);
      const productMatch = window.location.pathname.match(/^\/product\/([^/]+)$/);
      if (productMatch) {
        setCurrentProductId(productMatch[1]);
      } else {
        setCurrentProductId(null);
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleNavigate = (path) => {
    window.history.pushState({}, '', path);
    setCurrentPage(path);
    setCurrentProductId(null);
  };

  const handleProductClick = (productId) => {
    const productPath = routes.productDetail.replace(':id', productId);
    handleNavigate(productPath);
    setCurrentProductId(productId);
  };

  const handleAddToCart = (productToAdd) => {
    setCartItems((prevItems) => {
      const existingItemIndex = prevItems.findIndex((item) => item.id === productToAdd.id);

      if (existingItemIndex > -1) {
        const updatedItems = [...prevItems];
        updatedItems[existingItemIndex] = {
          ...updatedItems[existingItemIndex],
          quantity: updatedItems[existingItemIndex].quantity + productToAdd.quantity,
        };
        return updatedItems;
      } else {
        return [...prevItems, { ...productToAdd }];
      }
    });
    setPopupProduct(productToAdd);
    setShowAddToCartPopup(true);
  };

  const handleRemoveFromCart = (productId) => {
    setCartItems((prevItems) => prevItems.filter((item) => item.id !== productId));
  };

  const handleUpdateQuantity = (productId, newQuantity) => {
    setCartItems((prevItems) =>
      prevItems.map((item) =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      ).filter(item => item.quantity > 0)
    );
  };






  const handleFinalizePurchase = async (customerInfo) => {
  let total = 0;

  // Armar HTML del carrito para el correo
  const cartTableHtml = `
  <table style="width:100%; border-collapse: collapse;">
    <thead>
      <tr style="background-color: #f2f2f2;">
        <th style="padding: 8px; border: 1px solid #ddd;">Cantidad</th>
        <th style="padding: 8px; border: 1px solid #ddd;">Artículo</th>
        <th style="padding: 8px; border: 1px solid #ddd;">Precio Unitario</th>
        <th style="padding: 8px; border: 1px solid #ddd;">Subtotal</th>
      </tr>
    </thead>
    <tbody>
      ${cartItems.map(item => {
        const s = item.price * item.quantity;
        total += s;
        return `
        <tr>
          <td style="padding: 8px; border: 1px solid #ddd;">${item.quantity}</td>
          <td style="padding: 8px; border: 1px solid #ddd;">${item.name}</td>
          <td style="padding: 8px; border: 1px solid #ddd;">₡${item.price.toLocaleString('es-CR')}</td>
          <td style="padding: 8px; border: 1px solid #ddd;">₡${s.toLocaleString('es-CR')}</td>
        </tr>`;
      }).join('')}
    </tbody>
  </table>`;

  // 1) Email (EmailJS)
  try {
    await emailjs.send(
      'service_qvt55tp',
      'template_lx1phg8',
      {
        to_email: 'everdleiton@gmail.com',
        customer_name: `${customerInfo.name} ${customerInfo.lastName || ''}`.trim(),
        phone: customerInfo.phone,
        address: customerInfo.address,
        payment_method: customerInfo.paymentMethod,
        cart_items_html: cartTableHtml,
        total: `₡${total.toLocaleString('es-CR')}`,
      },
      'rgu5AncVlRVpZc2mY'
    );
  } catch (error) {
    console.error('EmailJS error:', error);
    alert('No se pudo enviar el correo. Inténtalo nuevamente.');
  }

  // 2) Guardar orden en Supabase
  try {
   const { data, error } = await supabase.from('orders').insert([{
  name: customerInfo.name,
                  // 👈 ya no lo pedimos
  phone: customerInfo.phone,
  address: customerInfo.address,
  payment_method: customerInfo.paymentMethod,
  cart: cartItems,
  total,
  cliente_id: user ? user.id : null,
}]);


    if (error) {
      console.error('Supabase INSERT error:', error);
      alert(`No se pudo guardar el pedido: ${error.message}`);
      return;
    }
  } catch (err) {
    console.error('Error inesperado guardando pedido:', err);
    alert('Error inesperado guardando el pedido.');
    return;
  }

  // 3) Reset + confirmación
  setLastOrderDetails({ cartItems: [...cartItems], total, customerInfo });
  setCartItems([]);
  setShowPurchaseConfirmation(true);
  handleNavigate(routes.home);
};



  const handleSearch = (term) => {
    setSearchTerm(term);
    handleNavigate(routes.search);
  };

  const renderPage = () => {
    const productMatch = currentPage.match(/^\/product\/([^/]+)$/);
    if (productMatch) {
      const productId = productMatch[1];
      return <ProductDetailPage productId={productId} onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
    }  // 👇 Pegá esto aquí
  const searchMatch = currentPage.match(/^\/search\/(.+)$/);
  if (searchMatch) {
    const term = decodeURIComponent(searchMatch[1]);
    return (
      <SearchPage
        searchTerm={term}
        onAddToCart={handleAddToCart}
        onProductClick={handleProductClick}
      />
    );
  }

    switch (currentPage) {
      case routes.home:
        return <HomePage onAddToCart={handleAddToCart} onProductClick={handleProductClick} onNavigate={handleNavigate} />;
      case routes.perfumes:
        return <CategoryPage category="perfumes" onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
      case routes.tecnologia:
        return <CategoryPage category="tecnologia" onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
      case routes.joyeria:
        return <CategoryPage category="joyeria" onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
    case routes.cart:
  return (
    <CartPage
      user={user}
      onNavigate={handleNavigate}   
      cartItems={cartItems}
      onRemoveFromCart={handleRemoveFromCart}
      onUpdateQuantity={handleUpdateQuantity}
      onFinalizePurchase={handleFinalizePurchase}
      onProductClick={handleProductClick}
      onAddToCart={handleAddToCart}
    />
  );

      case routes.privacy:
        return <PrivacyPolicyPage />;
      case routes.warranty:
        return <WarrantyPolicyPage />;
      case routes.search:
        return <SearchPage searchTerm={searchTerm} onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
case routes.registro:
  return <Registro onNavigate={handleNavigate} />;
case routes.misPedidos:
  return <MisPedidosPage user={user} onNavigate={handleNavigate} />;

case routes.miCuenta:
  return <MiCuenta user={user} onNavigate={handleNavigate} />;

case routes.login:
  return <LoginPage onNavigate={handleNavigate} onLoggedIn={handleLoggedIn} />;




      default:
        const categoryFromPath = currentPage.substring(1);
        const validCategories = ['perfumes', 'tecnologia', 'joyeria'];
        if (validCategories.includes(categoryFromPath)) {
          return <CategoryPage category={categoryFromPath} onAddToCart={handleAddToCart} onProductClick={handleProductClick} />;
        }
        return <HomePage onAddToCart={handleAddToCart} onProductClick={handleProductClick} onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="min-h-screen bg-white font-sans antialiased text-gray-800 flex flex-col">
      <Header
  onNavigate={handleNavigate}
  user={user}                     // 👈 pásale la sesión
  onLogout={handleLogout}         // 👈 pásale el logout
  cartItemCount={cartItems.reduce((sum, item) => sum + item.quantity, 0)}
  onSearch={handleSearch}
/>

      <main className="flex-grow pt-4">
        {renderPage()}
      </main>
      <Footer onNavigate={handleNavigate} />
      {showAddToCartPopup && popupProduct && (
        <AddToCartPopup product={popupProduct} onClose={() => setShowAddToCartPopup(false)} />
      )}
      {showPurchaseConfirmation && lastOrderDetails && (
        <PurchaseConfirmationModal
          onClose={() => setShowPurchaseConfirmation(false)}
          orderDetails={lastOrderDetails}
          customerInfo={lastOrderDetails.customerInfo}
        />
      )}
    </div>
  );
};

export default App;
